import CustomBand from '../../utils/customband'
import ProductAssets from '../../utils/product-assets'
import Color from '../../utils/color'
import _get from 'lodash/get'
import _clone from 'lodash/clone'

let RB = window.RB
let productAssets = new ProductAssets({
  product: RB.product,
  layout: RB.layout,
  artCategories: RB.clipArtCat,
  isAdmin: RB.admin
})

let defaultProductPrintStyleId = _get(RB, 'product_print_style_id', null)

let customBand = new CustomBand()
customBand.setProduct(productAssets, defaultProductPrintStyleId)
// console.log('_customBand', customBand)
let discount = _get(RB, 'discount', null)
customBand.discount = discount

// Initial state
const state = customBand

// getters
const getters = {}

// actions
const actions = {
  selectPrintStyle ({ state, commit, dispatch }, printStyle) {
    // Select the new print style
    commit('setPrintStyle', printStyle)

    // let positionChanges = state.checkPrintColorPositionsInNewPrintStyle(printStyle)
    let colorChanges = state.checkCurrentColorsAreInNewPrintStyle(printStyle)
    let fontChanges = state.checkCurrentFontsAreInNewPrintStyle(printStyle)

    // Apply all the changes
    for (let change of colorChanges) {
      commit('setColor', change)
    }
    for (let change of fontChanges) {
      commit('setFont', change)
    }

    dispatch('customstates/checkVisibleStates', printStyle, {root: true})
  },
  setPrintColor ({state, commit, dispatch}, payload) {
    // console.log('payload', payload)
    let newColor = payload.color
    let isGlobal = payload.isGlobal
    let rowPosition = _get(payload, 'rowPosition', state.customization.selected)

    // console.log('newColor', newColor)
    commit('setColor', newColor)

    if (!state.isFirstPrintColorSelected) {
      // state.setAllPrintColors(color);
      dispatch('setAllPrintColors', newColor)
      // state.isFirstPrintColorSelected = true;
      commit('setIsFirstPrintColorSelected', true)
    }

    if (isGlobal && state.isFirstPrintColorSelected) {
      // state.setAllPrintColors(color);
      dispatch('setAllPrintColors', newColor)
    }

    let globalColorFillPath = `customization.rows.${rowPosition}.colorFill`

    let setGlobalPrintColor = false
    if (state.customization.rows.length < 2) {
      if (state.selectedPrintColorsAreSameAsThisOne(payload.color.id)) {
        setGlobalPrintColor = true
      }
    } else {
      // We always set the global print color for each row
      setGlobalPrintColor = true
    }

    // console.log('setGlobalPrintColor', setGlobalPrintColor)

    if (setGlobalPrintColor) {
      // Set global print color
      let globalColor = _clone(newColor)
      globalColor._path = globalColorFillPath
      commit('setColor', globalColor)
    } else {
      // Remove global print color
      let globalColor = new Color({ _path: globalColorFillPath })
      commit('setColor', globalColor)
    }

  },
  setAllPrintColors ({ state, commit }, color) {
    let allTextAndGraphics = state.getAllTextsAndGraphics()
    for (let obj of allTextAndGraphics) {
      let manifestColorFill = _get(obj, 'manifest.colorFill', false)
      if (manifestColorFill) {
        // Copy the path into the new color object
        // color._path = obj._path
        let newColor = _clone(color)
        // console.log('newColor', newColor)
        // console.log('obj', obj)
        newColor._path = obj._path + '.colorFill'
        commit('setColor', newColor)
      }
    }
  },
  checkCompletion ({ state, commit, rootState }) {
    state.checkCompletion(commit, rootState.customstates, rootState.route, this._vm)

    // Update the Save Design form for staff members
    let manifest = document.getElementById('id_manifest')
    if (manifest) {
      // Manifest
      let manifestData = state.getPostData()['form-0-data']
      manifest.value = manifestData

      // Variant
      let defaultVariant = _get(state, 'product.variants.0.id')
      let variantData = _get(state, 'customization.rows[0].variant.id', defaultVariant)
      let variant = document.getElementById('id_variant')
      variant.value = variantData

      // Layout
      let layout = document.getElementById('id_layout')
      layout.value = state.layout.id
    }
  },
  removeRow ({ state, commit, dispatch }, rowIndex) {
    commit('removeRow', rowIndex)
    dispatch('selectRow', Math.max(rowIndex - 1, 0))
  },
  selectRow ({ state, commit, dispatch }, rowIndex) {
    commit('selectRow', rowIndex)

    if (state.hasAllTheSamePrintColors()) {
      let printColor = state.getGlobalPrintColor()
      dispatch('setAllPrintColors', printColor)
    }
  }
}

// mutations
const mutations = {
  setPrintStyle (state, printStyle) {
    state.customization.printStyle = printStyle
  },
  setColor (state, color) {
    state.setColor(color)
  },
  setIsFirstPrintColorSelected (state, value) {
    state.isFirstPrintColorSelected = value
  },
  setFont (state, payload) {
    state.setFont(payload.obj, payload.fontName)
  },
  setText (state, payload) {
    state.setText(payload.obj, payload.text)
  },
  setQty (state, payload) {
    let { rowIndex, qty } = payload
    state.setPathValue(`customization.rows.${rowIndex}.qty`, qty)
  },
  setNotes (state, notes) {
    state.customization.notes = notes
  },
  setGraphicImage (state, payload) {
    state.setGraphicImage(payload.obj, payload.image)
  },
  setGraphicCustom (state, payload) {
    state.setGraphicCustom(payload.obj, payload.custom)
  },
  setVariant (state, payload) {
    state.setVariant(payload.rowIndex, payload.variant)
  },
  resetGraphic (state, graphic) {
    graphic.id = graphic.image = graphic.name = graphic.custom = null
  },
  addRow (state, newRow = null) {
    state.addRow(newRow)
  },
  removeRow (state, rowIndex) {
    state.removeRow(rowIndex)
  },
  selectRow (state, rowIndex) {
    state.customization.selected = rowIndex
  },
  clearRows (state) {
    state.customization.rows = []
    state.customization.selected = 0
  },
  populateAreas (state, data) {
    state.populateAreas(data)
  },
  setFontChars (state, fontChars) {
    state.fontChars = fontChars
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
